import React, { Component } from "react"
import cookie from "react-cookies"

import { Row, Col, Input, Button, Tag } from "antd"
import PlusOutlined from "@ant-design/icons/PlusOutlined"
import { Cancel } from "@mui/icons-material"
import {aclPermissions, hasPermissions} from "../../const/ACLPermissions";


class CreateAndSearchBar extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <Row>
                <Col span={8}>
                    <Input.Search
                        allowClear
                        placeholder={`Search ${this.props.title || ""} by name`}
                        onSearch={this.props.handleSearch}
                        enterButton
                        size="medium"
                        suffix={<>{this.props.searchSelected.map(e =>
                            <Tag key={e} onClick={() => this.props.handleDeselect(e)} style={{ "display": "inline-flex", "marginLeft": "4px" }}>
                                <span style={{ marginTop: "4px" }}>{e}</span>
                                <Cancel style={{ transform: "scale(0.75)", margin: 0, padding: 0 }} />
                            </Tag>
                            )}
                        </>}
                    />
                </Col>
                <Col span={6}>
                    <Button type="danger" onClick={this.props.handleReset} style={{ marginLeft: 10 }}>
                        Reset
                    </Button>
                </Col>

                <Col span={6} offset={4}>
                    <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "flex-end" }}>
                            {hasPermissions([aclPermissions.create_case]) ? (
                                this.props.CreateButton || (
                                    <Button onClick={this.props.handleCreate}>
                                        {`Create New ${this.props.title || "Entity"}`} <PlusOutlined style={{ fontSize: "13px" }} />
                                    </Button>
                                )
                            )
                        : <></>
                    }
                    </div>
                </Col>
            </Row>
        )
    }
}

export default CreateAndSearchBar